import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "@seddi/ui-kit";
import { SkinTone } from "./avatars";
import * as S from "./skinInput.styles";
import { SkinButton } from "./skinButton";
const BasicSkinTones = [SkinTone.WHITE, SkinTone.GRAY, SkinTone.BLACK];
const monkSkinTones = [
    SkinTone.BROWN_0,
    SkinTone.BROWN_1,
    SkinTone.BROWN_2,
    SkinTone.BROWN_3,
    SkinTone.BROWN_4,
    SkinTone.BROWN_5,
    SkinTone.BROWN_6,
    SkinTone.BROWN_7,
    SkinTone.BROWN_8,
    SkinTone.BROWN_9,
];
export function SkinInput({ selection, onChange, }) {
    return (_jsxs(S.Container, { children: [_jsxs(S.Monk, { children: [_jsx(S.MonkGrid, { children: monkSkinTones.map((key) => {
                            const isSelected = key === selection;
                            return (_jsx(SkinButton, { isSelected: isSelected, onClick: () => {
                                    if (!isSelected) {
                                        onChange(key);
                                    }
                                }, skin: key }, key));
                        }) }), _jsx(Link, { onClick: () => window.open("https://skintone.google/", "_newtab"), text: "Why these skin tones?" })] }), _jsx(S.Basic, { children: _jsx(S.BasicGrid, { children: BasicSkinTones.map((key) => {
                        const isSelected = key === selection;
                        return (_jsx(SkinButton, { isSelected: isSelected, onClick: () => {
                                if (!isSelected) {
                                    onChange(key);
                                }
                            }, skin: key }, key));
                    }) }) })] }));
}
